import React from "react";

import DataTable from "../../../DataTable";

import useOutputReportStore from "../../../../store/OutputReport.store";
import {
  formatDataTableColumns,
  getOutputType,
} from "../../../../utils/helpers/dataTable";
import { dataTableCopy } from "../../../../utils/resources/dataTableCopy";

const getFootnote = ({ reportType, assetType }) => {
  if (
    reportType === "cash" &&
    (assetType === "treasury" || assetType === "corp" || assetType === "tbill")
  ) {
    return (
      <>
        {dataTableCopy.unlessOtherwiseStated}
        <br />
        [1]{dataTableCopy.targetPortfolios}
        <br />
        {dataTableCopy.hypotheticalInterestRate}
      </>
    );
  }
  if (reportType === "cash") {
    return (
      <>
        [1]{dataTableCopy.proposalNotMaintained}
        <br />
        [2]{dataTableCopy.seeReferenceIndex}
        <br />
        [3]{dataTableCopy.hypotheticalInterestRate}
      </>
    );
  }

  return (
    <>
      {dataTableCopy.unlessOtherwiseStated}
      <br />
      [1]{dataTableCopy.existingPortfolioInformation}
      <br />
      [2]{dataTableCopy.modelAndTransitionAnalysis}
      <br />
      [3]{dataTableCopy.seeReferenceIndex}
      <br />
      [4]{dataTableCopy.hypotheticalInterestRate}
    </>
  );
};

const getTableInfo = ({ reportType, assetType }) => {
  if (reportType === "cash" && assetType === "tbill") return;

  return (
    <div>
      Interest Rate Sensitivity Analysis: The scenario is modeled as a parallel
      shift to the US treasury curve. Interest rates are subject to change,
      which could materially impact the analysis provided.
    </div>
  );
};

const InterestRateAnalysisDataTable = () => {
  const reportName = "Interest Rate Analysis"; // Refer to corresponding API Key
  const data = useOutputReportStore((state) => state.data);
  const types = useOutputReportStore((state) => state.types);
  const { reportType, assetType } = getOutputType(data);
  const reportFormatting = types?.[reportName];

  const tableRowKeys = [
    {
      label: "-100",
      key: "-100",
    },
    {
      label: "-75",
      key: "-75",
    },
    {
      label: "-50",
      key: "-50",
    },
    {
      label: "-25",
      key: "-25",
    },
    {
      label: "0",
      key: "0",
    },
    {
      label: "25",
      key: "25",
    },
    {
      label: "50",
      key: "50",
    },
    {
      label: "75",
      key: "75",
    },
    {
      label: "100",
      key: "100",
    },
  ];

  const formatTypes = Object.keys(reportFormatting).reduce(
    (previous, key) => ({
      ...previous,
      [key]: reportFormatting[key][0],
    }),
    {}
  );

  return (
    <DataTable
      reportType={reportType}
      variation="stylized"
      tableCaption={`${reportName} Data Table`}
      tableRowHeaderKey="Yield Change (bps)"
      tableRowKeys={tableRowKeys}
      tableColumns={formatDataTableColumns(reportName, data)}
      tableDataTypes={formatTypes}
      formatCellDataBy="column"
      info={getTableInfo({ reportType, assetType })}
      footnote={getFootnote({ reportType, assetType })}
    />
  );
};

export default InterestRateAnalysisDataTable;
